import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CatalogFilterState } from "../types/reducers";

const initialState: CatalogFilterState = {
  species: {},
  imageTypes: {
    mosquito: false,
    mesh: false,
    emptyMesh: false,
    debris: false,
    bycatch: false,
    bookmarked: false,
  },
  trapsites: [],
  devices: [],
  capturedAfter: null,
  capturedBefore: null,
  page: 0,
};

const catalogFilterSlice = createSlice({
  name: "catalogFilter",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<CatalogFilterState>>) => {
      const { page, imageTypes, ...otherFilters } = action.payload;

      let isFilterChanged = false;

      if (imageTypes) {
        state.imageTypes = { ...state.imageTypes, ...imageTypes };
        isFilterChanged = true;
      }

      if (Object.keys(otherFilters).length > 0) {
        Object.assign(state, otherFilters);
        isFilterChanged = true;
      }

      if (page !== undefined) {
        state.page = page;
      } else if (isFilterChanged) {
        state.page = 0;
      }
    },
    resetCatalogFilters: () => initialState,
  },
});

export const { setFilters, resetCatalogFilters } = catalogFilterSlice.actions;

export default catalogFilterSlice.reducer;
